import fp from "lodash/fp";

import { usersService } from "services";

import { editUserConstants } from "./editUser.constants";

export const editUserActions = {
	loadHierarchy,
};

function loadHierarchy({ id }) {
	return dispatch => {
		dispatch(request());

		return usersService.getHierarchy({ id }).then(
			hierarchy => dispatch(success(hierarchy)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: editUserConstants.LOAD_HIERARCHY_REQUEST,
		};
	}

	function success(hierarchyResponse) {
		const { user, agentsCount, merchantsCount, merchants } =
			hierarchyResponse;
		user.agentsCount = agentsCount;
		user.merchantsCount = merchantsCount;

		if (!fp.isEmpty(merchants)) {
			user.children = [
				{
					id: "Merchants",
					role: "Merchants",
					children: [],
					merchants,
				},
				...user.children,
			];
		}

		return {
			type: editUserConstants.LOAD_HIERARCHY_SUCCESS,
			hierarchy: user,
		};
	}

	function failure(error) {
		return {
			type: editUserConstants.LOAD_HIERARCHY_SUCCESS,
			error,
		};
	}
}
